import { theme } from '../theme';

// Navigation styles
export const navigationStyles = {
  tab: {
    base: `px-6 py-3 rounded-lg transition-all duration-200 flex-grow text-sm md:text-base font-medium`,
    active: {
      background: `linear-gradient(to right, ${theme.colors.primary.main}, ${theme.colors.primary.hover})`,
      color: theme.colors.text.light,
      boxShadow: theme.shadows.md
    },
    inactive: {
      backgroundColor: 'white',
      color: theme.colors.text.secondary,
      hover: {
        backgroundColor: theme.colors.neutral.lighter,
        color: theme.colors.primary.main,
        transform: 'translateY(-2px)',
        boxShadow: theme.shadows.md
      }
    }
  },
  container: {
    base: `flex flex-wrap gap-2 px-6`,
    header: `bg-white shadow-lg rounded-b-2xl py-6 mb-8`
  }
};

// Header styles
export const headerStyles = {
  container: {
    base: `flex justify-between items-center px-6 mb-6`
  },
  title: {
    base: `text-3xl font-bold`,
    color: theme.colors.primary.main
  },
  subtitle: {
    base: `text-lg font-semibold mb-4`,
    color: theme.colors.primary.main
  }
};

// Card styles
export const cardStyles = {
  container: {
    base: `bg-white border rounded-xl shadow-lg p-8 mb-8`,
    borderColor: theme.colors.border.light
  },
  header: {
    base: `text-xl font-bold mb-6`,
    color: theme.colors.primary.main
  },
  content: {
    base: `leading-relaxed`,
    color: theme.colors.text.secondary
  }
};

// Project info styles
export const projectInfoStyles = {
  container: {
    base: `flex justify-between items-center p-4 rounded-lg`,
    backgroundColor: theme.colors.background.paper
  },
  label: {
    base: `font-semibold`,
    color: theme.colors.text.secondary
  },
  value: {
    base: `font-bold`,
    color: theme.colors.primary.main
  },
  metadata: {
    base: `text-sm font-medium`,
    color: theme.colors.text.secondary
  }
};

// Layout styles
export const layoutStyles = {
  page: {
    base: `container mx-auto px-4 relative min-h-screen pb-16`
  },
  section: {
    base: `space-y-6`
  },
  grid: {
    base: `grid grid-cols-1 md:grid-cols-2 gap-6`
  }
};

// Button styles
export const buttonStyles = {
  base: `px-6 py-3 rounded-lg font-medium transition-all duration-200 transform hover:-translate-y-0.5`,
  primary: {
    base: `text-white shadow-md hover:shadow-lg`,
    background: `linear-gradient(to right, ${theme.colors.primary.main}, ${theme.colors.primary.hover})`
  },
  secondary: {
    base: `text-white shadow-md hover:shadow-lg`,
    background: `linear-gradient(to right, ${theme.colors.secondary.main}, ${theme.colors.secondary.hover})`
  },
  accent: {
    base: `text-white shadow-md hover:shadow-lg`,
    background: `linear-gradient(to right, ${theme.colors.accent.main}, ${theme.colors.accent.hover})`
  }
};

// Form styles
export const formStyles = {
  input: {
    base: `w-full px-4 py-3 rounded-lg border-2 bg-white transition-all duration-200`,
    border: theme.colors.border.light,
    focus: {
      ring: theme.colors.primary.main,
      border: theme.colors.primary.main
    }
  },
  label: {
    base: `block text-sm font-semibold uppercase tracking-wide mb-2`,
    color: theme.colors.text.primary
  }
};

// Table styles
export const tableStyles = {
  container: {
    base: `w-full border-collapse`
  },
  header: {
    base: `p-4 text-left font-semibold border-b-2`,
    backgroundColor: theme.colors.neutral.light,
    color: theme.colors.text.primary,
    borderColor: theme.colors.border.main
  },
  cell: {
    base: `p-4 border-b`,
    borderColor: theme.colors.border.light,
    color: theme.colors.text.secondary
  },
  row: {
    hover: `hover:bg-gray-50 transition-colors`
  }
};
